/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  JobSpecTemplateDetailsDto,
  JobSpecTemplateListItemDto,
  JobSpecTemplateParagraphDto,
  JobSpecTemplateSectionDto,
  SpecTemplateClauses,
  SpecTemplateParagraphIs,
  SpecTemplateSectionIs,
  SpecTemplateStatus,
  SpecTemplateTextIs,
} from './job-spec-template.dto';

export const JobSpecTemplateListItemMapper = entity<JobSpecTemplateListItemDto>({
  statusValue: enumeration(SpecTemplateStatus),
});

export const JobSpecTemplateDetailsMapper = entity<JobSpecTemplateDetailsDto>({
  status: enumeration(SpecTemplateStatus),
  paragraphs: arrayOf(subentity<JobSpecTemplateParagraphDto>({
    paragraphIs: enumeration(SpecTemplateParagraphIs),
    textIs: enumeration(SpecTemplateTextIs),
    sections: arrayOf(subentity<JobSpecTemplateSectionDto>({
      sectionIs: enumeration(SpecTemplateSectionIs),
      textIs: enumeration(SpecTemplateTextIs),
      clausesAre: enumeration(SpecTemplateClauses),
    })),
  })),
});
